
export { default as getTrailFeatureLabel } from "./utils/getTrailFeatureLabel"